import { render, staticRenderFns } from "./xtCheckbox.vue?vue&type=template&id=7ada4e0c&scoped=true&"
import script from "./xtCheckbox.vue?vue&type=script&lang=js&"
export * from "./xtCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./xtCheckbox.vue?vue&type=style&index=0&id=7ada4e0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada4e0c",
  null
  
)

export default component.exports